import AWS from "aws-sdk";
import appConfig from './appConfig';
import React  from 'react';
import {Route, Switch, Link, Redirect} from 'react-router-dom'

import Home from './views/Home';
import Admin from './views/Admin';
import Post from './views/Post';
import LoginView from './views/LoginView';
import LogoutView from './views/LogoutView';
import RegisterView from './views/RegisterView';
import RecoverView from './views/RecoverView';
//import ResetPasswordView from './views/ResetPasswordView';
import ChangePasswordView from './views/ChangePasswordView';
import PageNotFound from './PageNotFound'

import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ActionHome from 'material-ui/svg-icons/action/home';
import Snackbar from 'material-ui/Snackbar';

//----
import FontIcon from 'material-ui/FontIcon';
import {BottomNavigation, BottomNavigationItem} from 'material-ui/BottomNavigation';
import Paper from 'material-ui/Paper';

const homeIcon = <FontIcon className="material-icons">ホーム</FontIcon>;
const loginIcon = <FontIcon className="material-icons">ログイン</FontIcon>;
const logoutIcon = <FontIcon className="material-icons">ログアウト</FontIcon>;
//----


/*****************************/
AWS.config.region = appConfig.region;
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: appConfig.IdentityPoolId
});
/*****************************/


export default class App extends React.Component {
  static propTypes = {
  }

  constructor(props) {
    super(props);
    this.state = {
      userId: null,
      errorValue: null
    }
    userIdFunc = this.handleUserId.bind(this);
    handleErrorFunc = this.handleError.bind(this);
  }



  /* ■ 再利用可能なテクニック
   * handleUserId()を子componentにexportして、App.jsのレンダリングが必要な時に呼んでもらう
   * login/logoutのメニューを切り替える時に、App.jsのレンダリングが必要になる
   * state.userIdを更新することで再レンダリングが行われる。<==state.userIdの値は特に使わない
   */
  handleUserId() {
  }


  handleError(errorValue) {
    this.setState({errorValue});
  }

  render () {

    // ログイン状態の確認はemailで行う
    let email = null;
    if( AWS.config.credentials.expired ) { //明示的なログアウトせずにcredentialsの期限切れを迎えた
        localStorage.removeItem('email');
    } else {
        email = localStorage.getItem('email');
    }

    const identityId = AWS.config.credentials.identityId;
    console.log("### AWS.config.credentials.identityId="+identityId);


    let errorSnackbarJSX = <Snackbar
        open={!!this.state.errorValue}
        message={this.state.errorValue?this.state.errorValue:""}
        autoHideDuration={8000}
        onRequestClose={ () => {console.log('You can add custom onClose code'); this.setState({errorValue:null});} } />;

    let homeLinksJSX = (
    <IconButton tooltip="go to home">
        <Link to='/'><ActionHome /></Link>
    </IconButton>);

     let menuLinksJSX=null;
     let bottomLinksJSX=null;
     if( !email ) {
         menuLinksJSX = 
           (<span>
              <Link to='/register'><RaisedButton label="登録" /></Link> 
              <Link to='/login'><RaisedButton label="ログイン" /></Link> 
              <Link to='/recover'><RaisedButton label="再発行" /></Link> 
            </span>);
          bottomLinksJSX =
            (<Link to='/login' style={{textAlign: 'right'}}>
                <BottomNavigationItem label="ログイン" icon={loginIcon}/>
             </Link>);

     } else {
         menuLinksJSX = 
           (<span>
              <Link to='/admin'><RaisedButton label="管理" /></Link> 
              <Link to='/logout'><RaisedButton label="ログアウト" /></Link> 
              <Link to='/change-password'><RaisedButton label="変更" /></Link> 
            </span>);

          bottomLinksJSX =
            (<Link to='/logout' style={{textAlign: 'right'}}>
                <BottomNavigationItem label="ログアウト" icon={logoutIcon}/>
             </Link>);
     }


    return (
      <div>
        <AppBar
            title='久喜SNS'
            iconElementLeft={homeLinksJSX}
            iconElementRight={menuLinksJSX} />

        <div>
          {errorSnackbarJSX}
          <Switch>
            <Route exact path='/' component={Home} name='home' />
            <Route path='/register' component={RegisterView} name='register' />
            <Route path='/login' component={LoginView} name='login' />
            <Route path='/logout' component={LogoutView} name='logout' />
            <Route path='/recover' component={RecoverView} name='recover' />
            <Route path='/change-password' component={ChangePasswordView} name='change' />
            <Route path='/post' component={Post} name='post' />
            <Route path='/admin'  render={ () => (
                (!!email) ? (
                    <Admin />
                ) : (
                    <Redirect to="/"/>
                )
            )}/>
            <Route component={PageNotFound}/>
          </Switch>
        </div>

        <br /><br /><br /><br />
        <Paper zDepth={1}>
          <BottomNavigation selectedIndex={this.state.selectedIndex}>
            <Link to='/'>
              <BottomNavigationItem label="トップページ" icon={homeIcon}/>
            </Link>
            {bottomLinksJSX}
          </BottomNavigation>
        </Paper>

      </div>
    );
  }

}

/* ■ 再利用可能なテクニック
 * Classの外で関数変数を定義し、Class内のMethodを代入して、exportする。
 */
let userIdFunc =  () => {}
let handleErrorFunc =  () => {}

export { userIdFunc, handleErrorFunc };




// WEBPACK FOOTER //
// ./src/App.js